import { useEffect, useMemo, useRef } from 'react'

import { useChatRoomSubscriptions } from '../../Providers/ChatRoomSubscriptions/ChatRoomSubscriptionsProvider.js'

interface Props {
  chatId: string
  subscriberId: string
  enabled: boolean
  delay?: number
}

export const useSubscribeToChat = ({
  chatId,
  subscriberId,
  delay,
  enabled,
}: Props) => {
  const { subscribeToChat, unsubscribeFromChat, state } =
    useChatRoomSubscriptions()
  const timerRef = useRef(null)

  useEffect(() => {
    if (!chatId) {
      return
    }

    if (delay && delay > 0) {
      timerRef.current = setTimeout(() => {
        if (enabled) {
          subscribeToChat(chatId, subscriberId)
        } else {
          unsubscribeFromChat(chatId, subscriberId)
        }
      }, delay)
    } else if (enabled) {
      subscribeToChat(chatId, subscriberId)
    } else {
      unsubscribeFromChat(chatId, subscriberId)
    }
  }, [
    chatId,
    subscriberId,
    subscribeToChat,
    unsubscribeFromChat,
    delay,
    enabled,
  ])

  useEffect(() => {
    /**
     * The unmount effect should be processed independent of enabled flag or it would
     * interfere with the delay parameter.
     */
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }

      unsubscribeFromChat(chatId, subscriberId)
    }
  }, [chatId, subscriberId, unsubscribeFromChat])

  const typingMembers = useMemo(() => {
    return state[chatId] ?? []
  }, [chatId, state])

  return {
    typingMembers,
  }
}
